// tslint:disable
export enum SiteLicenseType {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description STATE TAX ID
     */
    STTAXID = 1,
}
